<template>
<drawer :opened.sync="opened" style="min-width:700px;width:700px;" @close="onCloseBtnClick">
  <template #header>{{model.siteName}} {{model.siteDeviceName}} 异常录入</template>

  <template #body>
    <el-form ref="form" :model="model" @keydown.native.enter.prevent>
      <ul class="time-selector">
        <li
          v-for="(n, index) in 24"
          :key="index"
          :class="{
            'is-selected': selectedErrTimeMap[index],
            'selecting' : isSelecting && lastTimes[0] === index,
            'is-disabled': isSelecting && !canSelectRangeMap[index],
            'hover': hoverMap[index]
          }"
          class="time-item"
          @click="onTimeSelectorItemClick(index)"
          @mouseover="onTimeSelectorItemMouseOver(index)"
          @mouseout="onTimeSelectorItemMouseOut(index)"
        >
          <span
            :text="index.toString().padStart(2, '0')"
            class="time-item-text"
          ></span>
        </li>
      </ul>

      <div style="width:100%;height:1px;background-color:rgba(222, 222, 223, .5);"></div>

      <section class="error-times">
        <div class="error-time-label">异常时段：</div>
        <ul class="error-time-list">
          <li
            v-for="(times, index) in errTimes"
            :key="index"
            v-if="times.length === 2"
            class="error-time-item"
          >
            <span class="error-time-range">{{times[0].toString().padStart(2, '0')}}时{{times[1] !== times[0] ? ` - ${times[1].toString().padStart(2, '0')}时` : ''}}</span>
            <span class="error-time-delete-btn" @click="onDeleteErrorTimeBtnClick(index)">
              <i class="el-icon-delete"></i>删除
            </span>
          </li>
        </ul>
      </section>

      <el-form-item label="主要问题">
        <el-input v-model="model.trouble" type="textarea" :autosize="{minRows: 5}" />
      </el-form-item>

      <el-form-item label="解决计划">
        <el-input v-model="model.solution" type="textarea" :autosize="{minRows: 5}" />
      </el-form-item>
    </el-form>
    <h4 style="margin: 0;position: relative;top: 30px; color: #FE7300;">说明：<span style="font-size: 13px;">如果没有异常，则直接保存或者保存提交。</span></h4>
  </template>

  <template #footer>
    <el-button :disabled="isSelecting" type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
    <el-button :disabled="isSelecting" type="orange" plain class="btn save-continue-btn" @click="onSaveSubmitBtnClick">保存并提交</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseStore from '../../../../components/BaseStore'

export default {
  name: 'Editor',
  extends: BaseStore,
  data () {
    return {
      opened: false,
      model: {},
      errTimes: [],
      canSelectRangeMap: {},
      hoverMap: {}
    }
  },
  computed: {
    selectedErrTimeMap () {
      return this.errTimes.reduce((map, [beginTime, endTime]) => {
        for (let i = beginTime; i <= endTime; i++) {
          map[i] = true
        }

        return map
      }, {})
    },
    lastTimes () {
      let {errTimes} = this
      return errTimes[errTimes.length - 1] || []
    },
    isSelecting () {
      return this.lastTimes.length === 1
    }
  },
  methods: {
    open (data) {
      this.model = JSON.parse(JSON.stringify(data))
      this.errTimes = JSON.parse(data.errTime || '[]')
      this.opened = true
    },
    onTimeSelectorItemClick (time) {
      if (this.selectedErrTimeMap[time]) {
        return
      }

      let {errTimes, lastTimes} = this

      if ((lastTimes.length | 2) === 2) {
        let tmpMap = errTimes.reduce((map, [time0, time1]) => {
          if (time1 < time) {
            if (time1 > map.left) {
              map.left = time1
            }
          } else if (time0 < map.right) {
            map.right = time0
          }

          return map
        }, {
          left: -1,
          right: 24
        })

        let canSelectRangeMap = {}
        let right = tmpMap.right

        for (let i = tmpMap.left + 1; i < right; i++) {
          canSelectRangeMap[i] = true
        }

        this.canSelectRangeMap = Object.freeze(canSelectRangeMap)
        errTimes.push([time])
        return
      }

      if (!this.canSelectRangeMap[time]) {
        return
      }

      if (time < lastTimes[0]) {
        lastTimes.unshift(time)
      } else {
        lastTimes.push(time)
      }

      this.canSelectRangeMap = Object.freeze({})
      this.onTimeSelectorItemMouseOut()
    },
    onTimeSelectorItemMouseOver (time) {
      let {lastTimes} = this

      if (lastTimes.length !== 1) {
        return
      }

      let {canSelectRangeMap} = this
      let times = [lastTimes[0], time]
      let dir = (time - times[0]) >> -1
      let index = dir & 1
      let begin = times[index]
      let end = times[index ^ 1]
      let hoverMap = {}

      for (let i = begin; i <= end; i++) {
        if (canSelectRangeMap[i]) {
          hoverMap[i] = true
        }
      }

      this.hoverMap = Object.freeze(hoverMap)
    },
    onTimeSelectorItemMouseOut () {
      this.hoverMap = Object.freeze({})
    },
    onDeleteErrorTimeBtnClick (index) {
      let times = this.errTimes[index]
      this.$confirm(`本次删操将删除'${times[0].toString().padStart(2, '0')}时${times[1] !== times[0] ? ` - ${times[1].toString().padStart(2, '0')}时` : ''}'异常时间段, 是否继续?`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'confirm-dialog-confirm-btn',
        cancelButtonClass: 'confirm-dialog-cancel-btn',
        type: 'warning'
      }).then(() => {
        this.errTimes.splice(index, 1)
      }).catch(() => {})
    },
    save (callback) {
      let {model} = this
      model.errTime = JSON.stringify(this.errTimes)
      this.changeLoadStatus(true)

      let promise = this.$api.Operations.save(model, model.id ? 2 : 1)

      if (callback) {
        promise = promise.then(callback)
      }

      promise.then(() => {
        this.$emit('save')
        this.close()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    submit (data) {
      return this.$api.Operations.submit([data.id])
    },
    onSaveBtnClick () {
      this.save()
    },
    onSaveSubmitBtnClick () {
      this.save(this.submit)
    },
    onCloseBtnClick () {
      this.close()
    },
    close () {
      this.opened = false
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.time-selector {
  margin: 0;
  padding: 2.857142857142857% 0 0 0;
  user-select: none;
  overflow: hidden;

  &:after {
    content: "";
    display: table;
    clear: both;
  }

  .time-item {
    float: left;
    width: 5.714285714285714%;
    margin-bottom: 2.857142857142857%;
    border: 1px solid #dcdfe6 {
      radius: 5px;
    };
    color: #606266;
    text-align: center;
    cursor: pointer;

    & + .time-item:not(:nth-child(13)) {
      margin-left: 2.857142857142857%
    }

    &:hover {
      border-color: #c6e2ff;
      background-color: #ecf5ff;
      color: #409eff;
    }

    &:active {
      border-color: #3a8ee6;
      color: #3a8ee6;
    }

    &.is-disabled {
      border-color: #ebeef5;
      background-color: #fff;
      color: #c0c4cc;
      cursor: not-allowed;
    }

    &.selecting,
    &.hover {
      border-color: #c2e7b0;
      background-color: #f0f9eb;
      color: #67c23a;
    }

    &.is-selected {
      border-color: #F56C6C;
      background-color: #F56C6C;
      color: #ffffff;
      cursor: not-allowed;
    }

    .time-item-text {
      position: relative;
      display: block;
      padding-bottom: 100%;

      &:before {
        content: attr(text);
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        line-height: 0;
      }
    }
  }
}

.error-times {
  margin: 2.857142857142857% 0;
  line-height: 1.6;
  color: #606266;
  overflow: hidden;

  &:after {
    content: "";
    display: table;
    clear: both;
  }

  > * {
    float: left;
  }

  > .error-time-label {
    padding-right: 10px;
  }

  > .error-time-list {
    margin: 0;
    padding: 0;

    &:empty:before {
      content: "无";
    }

    > .error-time-item {
      > * {
        float: left;
      }

      > .error-time-range {
        width: 100px;
      }

      > .error-time-delete-btn {
        color: #f56c6c;
        cursor: pointer;
        user-select: none;

        &:hover {
          color: #ff0000;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/08Operations/02Log/01Submit/Editor.vue